import DeviceActionDropdown from './DeviceActionDropdown';
import { Flex, Typography } from 'antd';

const { Text } = Typography;

const SelectOptions = [
  { label: 'New Installation', value: 'install-a-new-device' },
  { label: 'Device Replacement', value: 'replace-old-device ' },
  { label: 'Device Uninstallation', value: 'uninstall-device' },
];

const DeviceManagementMobileHome = () => {
  return (
    <Flex
      align="center"
      justify="center"
      vertical
      style={{ minHeight: '100vh', width: '100%' }}
      gap={20}
    >
      <Text style={{ fontSize: 24, textAlign: 'center' }}>
        To get started, click on the “Action Form” to proceed
      </Text>
      <DeviceActionDropdown selectOptions={SelectOptions} />
    </Flex>
  );
};

export default DeviceManagementMobileHome;
